var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "bg-gray-100" }, [
      _c("header", { staticClass: "bg-white border-b-2 border-gray-300 p-4" }, [
        _c("h1", { staticClass: "text-2xl font-bold text-gray-800" }, [
          _vm._v(" PushHike Incident Response Policy ")
        ])
      ]),
      _c("main", { staticClass: "container mx-auto py-8 px-4" }, [
        _c("section", [
          _c("h2", { staticClass: "text-xl font-bold text-gray-800 mt-4" }, [
            _vm._v("Purpose")
          ]),
          _c("p", { staticClass: "mt-2" }, [
            _vm._v(
              " The purpose of this incident response policy is to provide a framework for identifying, assessing, and responding to security incidents related to the PushHike Shopify app. This policy is intended to minimize the impact of security incidents and ensure that PushHike's customers are notified of any relevant issues in a timely and transparent manner. "
            )
          ])
        ]),
        _c("section", [
          _c("h2", { staticClass: "text-xl font-bold text-gray-800 mt-4" }, [
            _vm._v("Scope")
          ]),
          _c("p", { staticClass: "mt-2" }, [
            _vm._v(
              " This incident response policy applies to all employees, contractors, and partners who work with or have access to PushHike's systems or data. This policy covers security incidents related to the PushHike Shopify app, including but not limited to: "
            )
          ]),
          _c("ul", { staticClass: "list-disc mt-2 ml-6" }, [
            _c("li", [_vm._v("Unauthorized access to customer data")]),
            _c("li", [_vm._v("Malware or other malicious code")]),
            _c("li", [_vm._v("Denial of service attacks")]),
            _c("li", [_vm._v("Data breaches")])
          ])
        ]),
        _c("section", [
          _c("h2", { staticClass: "text-xl font-bold text-gray-800 mt-4" }, [
            _vm._v(" Roles and Responsibilities ")
          ]),
          _c("p", { staticClass: "mt-2" }, [
            _vm._v(
              " PushHike's incident response team is responsible for implementing and enforcing this incident response policy. The incident response team consists of: "
            )
          ]),
          _c("ul", { staticClass: "list-disc mt-2 ml-6" }, [
            _c("li", [_vm._v("The CEO")]),
            _c("li", [_vm._v("The CTO")]),
            _c("li", [_vm._v("The lead developer")]),
            _c("li", [_vm._v("The lead customer support representative")])
          ]),
          _c("p", { staticClass: "mt-2" }, [
            _vm._v(
              " In the event of a security incident, the incident response team will be responsible for coordinating the response and communicating with all relevant parties. "
            )
          ])
        ]),
        _c("section", [
          _c("h2", { staticClass: "text-xl font-bold text-gray-800 mt-4" }, [
            _vm._v(" Incident Response Procedures ")
          ]),
          _c("ol", { staticClass: "list-decimal mt-2 ml-6" }, [
            _c("li", { staticClass: "mt-2" }, [
              _vm._v("Identify and Contain the Incident")
            ]),
            _c("p", { staticClass: "mt-2" }, [
              _vm._v(
                " Upon discovery of a security incident related to the PushHike Shopify app, the incident response team will take immediate steps to contain the incident and prevent further damage. This may include shutting down affected systems, isolating compromised data, or blocking unauthorized access. "
              )
            ]),
            _c("li", { staticClass: "mt-2" }, [_vm._v("Assess the Impact")]),
            _c("p", { staticClass: "mt-2" }, [
              _vm._v(
                " Once the incident has been contained, the incident response team will assess the impact of the incident to determine the extent of the damage and the potential risks to PushHike's customers. This may involve analyzing system logs, conducting forensic investigations, or consulting with outside experts. "
              )
            ]),
            _c("li", { staticClass: "mt-2" }, [
              _vm._v("Notify Relevant Parties")
            ]),
            _c("p", { staticClass: "mt-2" }, [
              _vm._v(
                " If the incident poses a risk to PushHike's customers or their data, the incident response team will notify all affected customers in a timely and transparent manner. This may involve sending email notifications, posting alerts on PushHike's website, or contacting customers directly. "
              )
            ]),
            _c("li", { staticClass: "mt-2" }, [
              _vm._v("Remediate and Recover")
            ]),
            _c("p", { staticClass: "mt-2" }, [
              _vm._v(
                " The incident response team will work to remediate any damage caused by the incident and restore affected systems to their normal state. This may involve patching vulnerabilities, restoring data from backups, or implementing new security controls. "
              )
            ]),
            _c("li", { staticClass: "mt-2" }, [_vm._v("Review and Improve")]),
            _c("p", { staticClass: "mt-2" }, [
              _vm._v(
                " After the incident has been resolved, the incident response team will conduct a review of the incident response procedures to identify any areas for improvement. This may involve updating policies and procedures, enhancing security controls, or providing additional training to employees. "
              )
            ])
          ])
        ]),
        _c("section", [
          _c("h2", { staticClass: "text-xl font-bold text-gray-800 mt-4" }, [
            _vm._v(" Conclusion ")
          ]),
          _c("p", { staticClass: "mt-2" }, [
            _vm._v(
              " PushHike is committed to protecting the security and privacy of our customers' data. This incident response policy provides a framework for responding to security incidents related to the PushHike Shopify app in a timely and effective manner. By following these procedures, we can minimize the impact of security incidents and maintain the trust of our customers. "
            )
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }